<template>
    <div v-if="user.role === 'superadmin'">

        <div v-if="includeTitle" class="d-flex comment-section pt-2 pb-1">
            <h2>{{ t("Logs") }}</h2>
        </div>

        <v-list>
            <v-list-item
                    v-for="item in logs"
                    :key="item.id"
                    style="border-radius: 10px; margin-bottom: 5px; background-color: #F0F0F0"
            >
                <v-list-item-content>
                    <v-list-item-title> {{ item.action }}</v-list-item-title>
                    <v-list-item-subtitle style="white-space: normal;"> {{ item.data }}</v-list-item-subtitle>
                    <v-list-item-subtitle class="font-weight-bold"> {{ item.created_at }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-row no-gutters>
                        <span class="font-italic">{{ item.created_by }}</span>
                    </v-row>
                </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="!logs || logs.length === 0">
                <v-list-item-content>
                    <v-list-item-title>{{ t("No logs found") }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "model-logs-list",
    props: {
        logs: {
            type: Array,
            required: true
        },
        includeTitle: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState(["user"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    }
};
</script>

<style scoped lang="scss">
.comment-section {
    margin-top: 36px;
    border-top: solid 1px black;
}
</style>
